/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CircleCheckLarge(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CircleCheckLarge',
      'aria-hidden': true,
      focusable: false,
      width:  20 * scale,
      height: 20 * scale,
      viewBox: '0 0 20 20',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18m-.935 13.46-4.097-3.994 1.396-1.432 2.57 2.506 4.556-5.315 1.518 1.302z"}))
}
